import { ScoreType } from './ScoreType';

export class ScoreWeight {
    public id: number;
    public scoreType: ScoreType;
    public weight: number;
    public value: number;
    public isDeleted: boolean;
}


// WEBPACK FOOTER //
// ./src/models/ScoreWeight.tsx